import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { FormAlert } from '@saucelabs/sl-component-form';
import { apiBaseUrls, loginPageFullPath } from '@saucelabs/sl-util-config';

import { operations } from './../ducks/container';
import FormTitle from './../components/FormTitle';
import FormWrapper from './../components/FormWrapper';
import HelpLinks from './../components/HelpLinks';
import SendPasswordResetForm from './../components/SendPasswordResetForm';

const SendPasswordResetContainer = ({ errorMessage, sendPasswordReset }) => (
  <FormWrapper>
    <Helmet>
      <title>Send Password Reset</title>
    </Helmet>
    <FormTitle>Forgot Your Password?</FormTitle>
    <FormAlert type="danger">{errorMessage}</FormAlert>
    <SendPasswordResetForm
      sendPasswordReset={sendPasswordReset}
    />
    <HelpLinks>
      <div>
        {'New to Sauce Labs? '}
        <a href={apiBaseUrls.signup}>
          Create an Account
        </a>
      </div>
      <div>
        {'Remember your Password? '}
        <a href={loginPageFullPath}>
          Login here
        </a>
      </div>
    </HelpLinks>
  </FormWrapper>
);

const mapStateToProps = (store, { location: { state } }) => ({
  errorMessage: state && state.error,
});

const mapDispatchToProps = {
  sendPasswordReset: operations.sendPasswordReset,
};

SendPasswordResetContainer.propTypes = {
  errorMessage: PropTypes.string,
  sendPasswordReset: PropTypes.func.isRequired,
};

SendPasswordResetContainer.defaultProps = {
  errorMessage: null,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SendPasswordResetContainer),
);
export { SendPasswordResetContainer, mapDispatchToProps };
